import {safeJSONparse} from '../../../common/util/safeJSONparse';

export function viewWithDataGetAllData(viewWithData) {
    if (!viewWithData) {
        return [];
    }

    let data = viewWithData.data;
    data = safeJSONparse(data);

    return data;
}

export function viewWithDataGetPrimaryData(viewWithData) {
    let data = viewWithDataGetAllData(viewWithData);

    let primaryKey = null;

    if (Array.isArray(data)) {
        return data.map((row) => {
            if (!primaryKey) {
                if ('primary-data' in row) {
                    primaryKey = 'primary-data';
                } else {
                    let keys = Object.keys(row);
                    if (keys.length > 0) {
                        primaryKey = keys[0];
                    }
                }
            }

            return row[primaryKey];
        });
    }

    return [];
}
